import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListCoupons from "../Components/Coupons/listCoupons";
import ViewCoupons from "../Components/Coupons/viewCoupons";
import AddCoupons from "../Components/Coupons/addCoupons";
import EditCoupons from "../Components/Coupons/editCoupons";

const CouponsRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route
        path="/create_coupons"
        element={<ListCoupons></ListCoupons>}
      ></Route>
      <Route
        path="/create_coupons/view/:id"
        element={<ViewCoupons></ViewCoupons>}
      ></Route>
      <Route
        path="/create_coupons/add"
        element={canAdd ? <AddCoupons /> : <Navigate to="/create_coupons" replace />}></Route>
      <Route
        path="/create_coupons/edit/:id"
        element={canEdit ? <EditCoupons /> : <Navigate to="/create_coupons" replace ></Navigate>}
      ></Route>
    </Routes>
  );
};

export default CouponsRoutes;
